/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as msRest from "@azure/ms-rest-js";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as Parameters from "./models/parameters";
import { NavigationAPIContext } from "./navigationAPIContext";

class NavigationAPI extends NavigationAPIContext {
  /**
   * Initializes a new instance of the NavigationAPI class.
   * @param [options] The parameter options
   */
  constructor(options?: Models.NavigationAPIOptions) {
    super(options);
  }

  /**
   * By passing in the appropriate options, you can search for
   * available inventory in the system
   * @summary returns site structure
   * @param currentNodeId the Id for the current node
   * @param [options] The optional parameters
   * @returns Promise<Models.GetNavigationResponse>
   */
  getNavigation(currentNodeId: number, options?: msRest.RequestOptionsBase): Promise<Models.GetNavigationResponse>;
  /**
   * @param currentNodeId the Id for the current node
   * @param callback The callback
   */
  getNavigation(currentNodeId: number, callback: msRest.ServiceCallback<any>): void;
  /**
   * @param currentNodeId the Id for the current node
   * @param options The optional parameters
   * @param callback The callback
   */
  getNavigation(currentNodeId: number, options: msRest.RequestOptionsBase, callback: msRest.ServiceCallback<any>): void;
  getNavigation(currentNodeId: number, options?: msRest.RequestOptionsBase | msRest.ServiceCallback<any>, callback?: msRest.ServiceCallback<any>): Promise<Models.GetNavigationResponse> {
    return this.sendOperationRequest(
      {
        currentNodeId,
        options
      },
      getNavigationOperationSpec,
      callback) as Promise<Models.GetNavigationResponse>;
  }
}

// Operation Specifications
const serializer = new msRest.Serializer(Mappers);
const getNavigationOperationSpec: msRest.OperationSpec = {
  httpMethod: "GET",
  path: "navigation/{currentNodeId}",
  urlParameters: [
    Parameters.currentNodeId
  ],
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Object"
        }
      }
    },
    400: {},
    default: {}
  },
  serializer
};

export {
  NavigationAPI,
  NavigationAPIContext,
  Models as NavigationAPIModels,
  Mappers as NavigationAPIMappers
};
